import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { Grid, Dialog, Button, SubmitButton // Debug,
, SearchSelect, DatePicker } from "../../../../../";
import { makeStyles } from "@material-ui/styles";
import { Typography, Divider } from "@material-ui/core";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    containerButtonsAttendance: {
      marginTop: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around"
    },
    containerActions: {
      marginTop: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    containedYellow: {
      color: "#000",
      background: "#ffe082"
    },
    outlinedYellow: {
      color: "#ffe082",
      border: "1px solid #ffe082"
    }
  };
});
var attendanceSchema = Yup.object().shape({
  date: Yup.string().required(),
  group: Yup.string().required(),
  key: Yup.string().required(),
  status: Yup.string().matches(/yes|no|maybe/).required()
});

var MobileDialogCampusCalendarAddAttendance = function MobileDialogCampusCalendarAddAttendance(props) {
  // console.log("MobileDialogCampusCalendarAddAttendance props", props);
  var classes = useStyles();
  var initialValues = props.data || {
    date: null,
    key: null,
    status: null
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: attendanceSchema,
    onSubmit: function onSubmit(values) {
      props.onSubmit({
        group: values.group,
        info: _objectSpread(_objectSpread({}, values), {}, {
          date: moment(values.date).format("DD/MM/YYYY"),
          name: props.children.find(function (child) {
            return child.key === values.key;
          }).name
        })
      });
      props.onClose();
    },
    render: function render(_ref) {
      var values = _ref.values,
          isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting,
          setFieldValue = _ref.setFieldValue;
      return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        align: "center"
      }, props.translation ? props.translation.title || "Notify Attendance" : "Notify Attendance")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Field, {
        component: DatePicker,
        label: props.translation ? props.translation.inputs ? props.translation.inputs.date || "Date" : "Date" : "Date",
        name: "date",
        variant: "outlined",
        fullWidth: true,
        margin: "normal"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Field, {
        name: "key",
        key: "key",
        component: SearchSelect,
        mobile: true,
        label: props.translation ? props.translation.selects ? props.translation.selects.child || "Child" : "Child" : "Child",
        options: props.children.map(function (child) {
          return {
            label: child.name,
            value: child.key
          };
        }),
        placeholder: "",
        variant: "outlined"
      })), values.key ? /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Field, {
        name: "group",
        key: "group",
        component: SearchSelect,
        mobile: true,
        label: props.translation ? props.translation.selects ? props.translation.selects.group || "Group" : "Group" : "Group",
        options: props.children.find(function (child) {
          return child.key === values.key;
        }).groups.map(function (group) {
          return {
            label: group.name,
            value: group.key
          };
        }),
        placeholder: "",
        variant: "outlined"
      })) : null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, props.translation ? props.translation.labels ? props.translation.labels.attendance || "Will he/she attend?" : "Will he/she attend?" : "Will he/she attend?"), /*#__PURE__*/React.createElement("div", {
        className: classes.containerButtonsAttendance
      }, /*#__PURE__*/React.createElement(Button, {
        variant: values.status === "yes" ? "contained" : "outlined",
        color: "primary",
        onClick: function onClick() {
          return setFieldValue("status", "yes");
        }
      }, props.translation ? props.translation.buttons ? props.translation.buttons.yes || "Yes" : "Yes" : "Yes"), /*#__PURE__*/React.createElement(Button, {
        variant: values.status === "maybe" ? "contained" : "outlined",
        className: values.status === "maybe" ? classes.containedYellow : classes.outlinedYellow,
        onClick: function onClick() {
          return setFieldValue("status", "maybe");
        }
      }, props.translation ? props.translation.buttons ? props.translation.buttons.maybe || "Maybe" : "Maybe" : "Maybe"), /*#__PURE__*/React.createElement(Button, {
        variant: values.status === "no" ? "contained" : "outlined",
        color: "secondary",
        onClick: function onClick() {
          return setFieldValue("status", "no");
        }
      }, props.translation ? props.translation.buttons ? props.translation.buttons.no || "No" : "No" : "No"))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.containerActions
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save"))));
    }
  }));
};

export { MobileDialogCampusCalendarAddAttendance };